import { render } from "./eventlist.vue?vue&type=template&id=1816590d"
import script from "./eventlist.vue?vue&type=script&lang=js"
export * from "./eventlist.vue?vue&type=script&lang=js"

import "./eventlist.vue?vue&type=style&index=0&id=1816590d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__